/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ICmpComment } from "./i-cmp-comment";

export class CmpTaskComment extends ICmpComment {
    cmpTaskCommentId: string = undefined;
    taskId: string = undefined;
    isCustomerVisible: boolean = undefined;
    createdById: string = undefined;
}
